exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table__LedgersPosting-module___2ki4n {\n    border-top: 2px solid black;\n\n}\n.table__LedgersPosting-module___2ki4n:last-child {\n    border-top: 2px solid black;\n    border-bottom: 2px solid black;\n}\n\n@media only screen and (max-width: 1832px) {\n    .container__LedgersPosting-module___H308G {\n        overflow: auto;\n    }\n}\n", ""]);

// Exports
exports.locals = {
	"table": "table__LedgersPosting-module___2ki4n",
	"container": "container__LedgersPosting-module___H308G"
};